"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const SAGE_PINK = "#E0457B";

const SageInconsistentInterviewSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 5, sm: 7, md: 12 },
        backgroundColor: "#FFFFFF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: { xs: 4, md: 6, lg: 8 },
            alignItems: "start",
          }}
        >
          {/* Left - Label + Heading */}
          <Box>
            <Typography
              sx={{
                fontSize: { xs: "10px", sm: "11px" },
                fontWeight: 600,
                color: SAGE_PINK,
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                fontFamily: "var(--font-outfit)",
                mb: { xs: 1.5, sm: 2 },
              }}
            >
              {t("sageInconsistentInterview.label")}
            </Typography>

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "26px", sm: "30px", md: "34px", lg: "38px" },
                fontWeight: 700,
                lineHeight: 1.2,
                color: "#14122B",
                fontFamily: "var(--font-plusjakarta)",
              }}
            >
              {t("sageInconsistentInterview.heading")}
            </Typography>
          </Box>

          {/* Right - Paragraphs with pink line */}
          <Box
            sx={{
              [isArabic ? "borderRight" : "borderLeft"]: `2px solid ${SAGE_PINK}`,
              [isArabic ? "pr" : "pl"]: { xs: 2.5, sm: 3, md: 4 },
              display: "flex",
              flexDirection: "column",
              gap: { xs: 2.5, md: 3 },
              py: { xs: 0, md: 0.5 },
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "15px" },
                color: "#2E2B4A",
                lineHeight: 1.8,
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("sageInconsistentInterview.paragraph1")}
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "15px" },
                color: "#2E2B4A",
                lineHeight: 1.8,
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("sageInconsistentInterview.paragraph2")}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SageInconsistentInterviewSection;